


const TableRow = (props) => {

    return (
        <tr>
            <td><img className="tableRow__img" alt={props.title} src={props.img} /></td>
            <td>{props.title}</td>
            {!props.movieOrSerie ? undefined : <td>{props.movieOrSerie === "serie" ? "series" : "peliculas"}</td>}
            <td><button name="editar" onClick={props.update}>editar</button></td>
            <td><button name="eliminar" onClick={props.delete}>eliminar</button></td>

        </tr>
    )
}

export default TableRow